var $c9bdc51a8202ae67$exports = {};
$c9bdc51a8202ae67$exports = {
    "info": `\u{60C5}\u{5831}`,
    "negative": `\u{30A8}\u{30E9}\u{30FC}`,
    "notice": `\u{8B66}\u{544A}`,
    "positive": `\u{6210}\u{529F}`
};


export {$c9bdc51a8202ae67$exports as default};
//# sourceMappingURL=ja-JP.mjs.map
